import React from 'react';

function CardCTA({ text, disabled = false, onBtnClick, buttonType = 'button', extraClass = '' }) {
  return (
    <button
      className={`c-btn c-btn--cta ${extraClass}`}
      disabled={disabled}
      type={buttonType}
      onClick={onBtnClick}
    >
      {text}
    </button>
  );
}

export default CardCTA;



// WEBPACK FOOTER //
// ./src/parts/CardCTA.js